import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link as RouterLink, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { cores } from '../../theme';

import {
    Typography, Container, Box, CircularProgress, Alert, Paper, Button, List, ListItem, ListItemText, Divider,
    Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, TextField, Autocomplete, Link,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton,
    FormControl, InputLabel, Select, MenuItem, Tabs, Tab, Menu, Fade, ListItemIcon, Avatar, useTheme
} from '@mui/material';
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    ArrowBack,
    MoreVert as MoreVertIcon,
    Warning as WarningIcon,
    CalendarMonth as CalendarIcon,
    Add as AddIcon,
    Close as CloseIcon,
    Check as CheckIcon,
    ManageAccounts as ManageAccountsIcon,
    Upload as UploadIcon,
    CloudDownload as CloudDownloadIcon,
    FileUpload as FileUploadIcon
} from '@mui/icons-material';

const TurmaDetalhePagina = () => {
    const { id: turmaId } = useParams();
    const navegar = useNavigate();
    const [dados, setDados] = useState(null);
    const [agendamentos, setAgendamentos] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [periodos, setPeriodos] = useState([]);
    const [carregando, setCarregando] = useState(true);
    const [erro, setErro] = useState('');
    const [modalAberto, setModalAberto] = useState({ aluno: false, professor: false, agendamento: false, grupo: false, periodo: false });
    const [modoCriacaoAluno, setModoCriacaoAluno] = useState(false);
    const [editandoPeriodo, setEditandoPeriodo] = useState(null);
    const [editandoGrupo, setEditandoGrupo] = useState(null);
    const [opcoesBusca, setOpcoesBusca] = useState([]);
    const [selecionado, setSelecionado] = useState(null);
    const [novoAluno, setNovoAluno] = useState({ nome: '', matricula: '', email: '' });
    const [novoGrupoNome, setNovoGrupoNome] = useState('');
    const [formPeriodo, setFormPeriodo] = useState({ nome: '', data_inicio: '', data_fim: '' });
    const [listasParaModal, setListasParaModal] = useState({ grupos: [], casos: [], periodos: [] });
    const [novoAgendamento, setNovoAgendamento] = useState({
        grupo_tutoria_id: '',
        caso_clinico_id: '',
        periodo_avaliacao_id: '',
        data_liberacao: ''
    });
    const [abaAtual, setAbaAtual] = useState(0);
    const [menuAnchorEl, setMenuAnchorEl] = useState({
        id: null,
        element: null,
        tipo: null
    });
    const [dialogoConfirmacao, setDialogoConfirmacao] = useState({
        aberto: false,
        periodoId: null,
        nomePeriodo: ''
    });
    const [dialogoConfirmacaoAgendamento, setDialogoConfirmacaoAgendamento] = useState({
        aberto: false,
        agendamentoId: null,
        descricao: ''
    });
    const [dialogoConfirmacaoGrupo, setDialogoConfirmacaoGrupo] = useState({
        aberto: false,
        grupoId: null,
        nome: ''
    });
    const [dialogoConfirmacaoProfessor, setDialogoConfirmacaoProfessor] = useState({
        aberto: false,
        professorId: null,
        nome: ''
    });
    const [dialogoConfirmacaoAluno, setDialogoConfirmacaoAluno] = useState({
        aberto: false,
        alunoId: null,
        nome: ''
    });
    const [modalImportacaoAberto, setModalImportacaoAberto] = useState(false);
    const [arquivoSelecionado, setArquivoSelecionado] = useState(null);
    const [processandoImportacao, setProcessandoImportacao] = useState(false);
    const [resultadoImportacao, setResultadoImportacao] = useState(null);
    const [erroImportacao, setErroImportacao] = useState('');
    const theme = useTheme();

    const mudarAba = (event, novoValor) => {
        setAbaAtual(novoValor);
    };

    const buscarDadosDaPagina = useCallback(async () => {
        try {
            setErro('');
            const [respDetalhes, respAgendamentos, respGrupos, respPeriodos] = await Promise.all([
                api.get(`/api/turmas/${turmaId}/detalhes`),
                api.get(`/api/agendamentos/turma/${turmaId}`),
                api.get(`/api/turmas/${turmaId}/grupos`),
                api.get(`/api/turmas/${turmaId}/periodos`)
            ]);
            setDados(respDetalhes.data);
            setAgendamentos(respAgendamentos.data);
            setGrupos(respGrupos.data);
            setPeriodos(respPeriodos.data);
        } catch (err) {
            setErro('Falha ao carregar os dados da turma.');
        } finally {
            if (carregando) setCarregando(false);
        }
    }, [turmaId, carregando]);

    useEffect(() => {
        buscarDadosDaPagina();
    }, [buscarDadosDaPagina]);

    const fecharModais = () => {
        setModalAberto({ aluno: false, professor: false, agendamento: false, grupo: false, periodo: false });
        setModoCriacaoAluno(false);
        setEditandoPeriodo(null);
        setEditandoGrupo(null);
        setSelecionado(null);
        setOpcoesBusca([]);
        setNovoAluno({ nome: '', matricula: '', email: '' });
        setNovoGrupoNome('');
        setFormPeriodo({ nome: '', data_inicio: '', data_fim: '' });
    };

    const abrirModal = async (tipo, itemParaEditar = null) => {
        fecharModais();
        if (tipo === 'PERIODO') {
            if (itemParaEditar) {
                setEditandoPeriodo(itemParaEditar);
                setFormPeriodo({
                    nome: itemParaEditar.nome,
                    data_inicio: new Date(itemParaEditar.data_inicio).toISOString().split('T')[0],
                    data_fim: new Date(itemParaEditar.data_fim).toISOString().split('T')[0]
                });
            }
            setModalAberto({ ...modalAberto, periodo: true });
        } else if (tipo === 'ALUNO' || tipo === 'PROFESSOR') {
            try {
                const resposta = await api.get(`/api/usuarios/disponiveis-para-turma/${turmaId}?cargo=${tipo}`);
                setOpcoesBusca(resposta.data);
            } catch (err) { console.error(err); }
            if (tipo === 'ALUNO') setModalAberto({ ...modalAberto, aluno: true });
            if (tipo === 'PROFESSOR') setModalAberto({ ...modalAberto, professor: true });
        } else if (tipo === 'AGENDAMENTO') {
            try {
                const [respGrupos, respCasos, respPeriodos] = await Promise.all([
                    api.get(`/api/turmas/${turmaId}/grupos`),
                    api.get('/api/casos-clinicos'),
                    api.get(`/api/turmas/${turmaId}/periodos`)
                ]);
                setListasParaModal({ grupos: respGrupos.data, casos: respCasos.data, periodos: respPeriodos.data });
                setModalAberto({ ...modalAberto, agendamento: true });
            } catch (err) { alert("Erro ao carregar dados para o agendamento."); }
        } else if (tipo === 'GRUPO') {
            if (itemParaEditar) {
                setEditandoGrupo(itemParaEditar);
                setNovoGrupoNome(itemParaEditar.nome);
            }
            setModalAberto({ ...modalAberto, grupo: true });
        }
    };

    const lidarComBusca = async (event, value, cargo) => {
        if (!event || value.length < 2) return setOpcoesBusca([]);
        try {
            const resposta = await api.get(`/api/usuarios/disponiveis-para-turma/${turmaId}?cargo=${cargo}&search=${value}`);
            setOpcoesBusca(resposta.data);
        } catch (err) { console.error(`Erro na busca de ${cargo}:`, err); }
    };

    const lidarComSalvarPeriodo = async () => {
        if (!formPeriodo.nome || !formPeriodo.data_inicio || !formPeriodo.data_fim) return alert("Todos os campos são obrigatórios.");
        try {
            if (editandoPeriodo) {
                await api.put(`/api/periodos/${editandoPeriodo.id}`, formPeriodo);
            } else {
                await api.post(`/api/turmas/${turmaId}/periodos/criar`, formPeriodo);
            }
            fecharModais();
            buscarDadosDaPagina();
        } catch (err) { alert("Erro ao salvar o período."); }
    };

    const lidarComDeletarPeriodo = async (periodoId) => {
        if (window.confirm("Tem certeza que deseja deletar este período?")) {
            try {
                await api.delete(`/api/periodos/${periodoId}`);
                buscarDadosDaPagina();
            } catch (err) { alert(err.response?.data?.erro || "Erro ao deletar o período."); }
        }
    };

    const abrirMenuAcoes = (event, id, tipo) => {
        setMenuAnchorEl({
            id: id,
            element: event.currentTarget,
            tipo: tipo
        });
    };

    const fecharMenuAcoes = () => {
        setMenuAnchorEl({
            id: null,
            element: null,
            tipo: null
        });
    };

    const abrirDialogoConfirmacao = (periodoId, nomePeriodo) => {
        setDialogoConfirmacao({
            aberto: true,
            periodoId,
            nomePeriodo
        });
        fecharMenuAcoes();
    };

    const fecharDialogoConfirmacao = () => {
        setDialogoConfirmacao({
            aberto: false,
            periodoId: null,
            nomePeriodo: ''
        });
    };

    const confirmarDelecaoPeriodo = async () => {
        try {
            await api.delete(`/api/periodos/${dialogoConfirmacao.periodoId}`);
            setPeriodos(periodosAtuais => periodosAtuais.filter(p => p.id !== dialogoConfirmacao.periodoId));
            fecharDialogoConfirmacao();
        } catch (err) {
            alert(err.response?.data?.erro || "Erro ao deletar o período.");
            fecharDialogoConfirmacao();
        }
    };

    const lidarComCriarGrupo = async () => {
        if (!novoGrupoNome) return alert("O nome do grupo é obrigatório.");
        try {
            if (editandoGrupo) {
                await api.put(`/api/grupos/${editandoGrupo.id}`, { nome: novoGrupoNome });
            } else {
                await api.post(`/api/turmas/${turmaId}/grupos/criar`, { nome: novoGrupoNome });
            }
            fecharModais();
            buscarDadosDaPagina();
        } catch (err) {
            alert(editandoGrupo ? "Erro ao atualizar o grupo." : "Erro ao criar o grupo.");
        }
    };

    const lidarComAdicionarProfessor = async () => {
        if (!selecionado) return alert("Selecione um professor.");
        try {
            await api.post(`/api/turmas/${turmaId}/adicionar-professor`, { professor_id: selecionado.id });
            fecharModais();
            buscarDadosDaPagina();
        } catch (err) { alert("Erro ao adicionar professor."); }
    };

    const lidarComAdicionarAluno = async () => {
        if (modoCriacaoAluno) {
            if (!novoAluno.nome || !novoAluno.email || !novoAluno.matricula) return alert("Preencha todos os campos do novo aluno.");
            try {
                const dadosNovoAluno = { nome_completo: novoAluno.nome, email: novoAluno.email, matricula: novoAluno.matricula, cargo: 'ALUNO' };
                const resposta = await api.post('/api/usuarios/criar-pendente', dadosNovoAluno);
                await api.post(`/api/turmas/${turmaId}/adicionar-aluno`, { aluno_id: resposta.data.id });
            } catch (err) { return alert(err.response?.data?.erro || "Erro ao criar e adicionar aluno."); }
        } else {
            if (!selecionado) return alert("Selecione um aluno da lista.");
            try {
                await api.post(`/api/turmas/${turmaId}/adicionar-aluno`, { aluno_id: selecionado.id });
            } catch (err) { return alert("Erro ao adicionar aluno existente."); }
        }
        fecharModais();
        buscarDadosDaPagina();
    };

    const lidarComRemover = async (idUsuario, cargo) => {
        let usuario;
        if (cargo === 'ALUNO') {
            usuario = dados.alunos.find(a => a.id === idUsuario);
            if (usuario) {
                abrirDialogoConfirmacaoAluno(idUsuario, usuario.nome_completo);
            }
        } else {
            usuario = dados.professores.find(p => p.id === idUsuario);
            if (usuario) {
                abrirDialogoConfirmacaoProfessor(idUsuario, usuario.nome_completo);
            }
        }
    };

    const lidarComMudancaAgendamento = (e) => {
        const { name, value } = e.target;
        setNovoAgendamento(prev => ({ ...prev, [name]: value }));
    };

    const lidarComSalvarAgendamento = async () => {
        if (!novoAgendamento.grupo_tutoria_id || !novoAgendamento.caso_clinico_id || !novoAgendamento.periodo_avaliacao_id) return alert("Por favor, preencha todos os campos.");
        try {
            const dadosAgendamento = {
                ...novoAgendamento,
                data_liberacao: novoAgendamento.data_liberacao ? new Date(novoAgendamento.data_liberacao).toISOString() : undefined
            };

            await api.post('/api/agendamentos/criar', dadosAgendamento);
            fecharModais();
            buscarDadosDaPagina();
        } catch (err) { alert("Erro ao salvar agendamento."); }
    };

    const abrirDialogoConfirmacaoAgendamento = (agendamentoId, descricao) => {
        setDialogoConfirmacaoAgendamento({
            aberto: true,
            agendamentoId,
            descricao
        });
    };

    const fecharDialogoConfirmacaoAgendamento = () => {
        setDialogoConfirmacaoAgendamento({
            aberto: false,
            agendamentoId: null,
            descricao: ''
        });
    };

    const confirmarDelecaoAgendamento = async () => {
        try {
            await api.delete(`/api/agendamentos/${dialogoConfirmacaoAgendamento.agendamentoId}`);
            setAgendamentos(agendamentosAtuais => agendamentosAtuais.filter(a => a.id !== dialogoConfirmacaoAgendamento.agendamentoId));
            fecharDialogoConfirmacaoAgendamento();
        } catch (err) {
            alert(err.response?.data?.erro || "Erro ao excluir o agendamento.");
            fecharDialogoConfirmacaoAgendamento();
        }
    };

    const abrirDialogoConfirmacaoProfessor = (professorId, nome) => {
        setDialogoConfirmacaoProfessor({
            aberto: true,
            professorId,
            nome
        });
    };

    const fecharDialogoConfirmacaoProfessor = () => {
        setDialogoConfirmacaoProfessor({
            aberto: false,
            professorId: null,
            nome: ''
        });
    };

    const confirmarRemocaoProfessor = async () => {
        try {
            await api.delete(`/api/turmas/${turmaId}/professores/${dialogoConfirmacaoProfessor.professorId}`);
            buscarDadosDaPagina();
            fecharDialogoConfirmacaoProfessor();
        } catch (err) {
            alert(err.response?.data?.erro || "Erro ao remover o professor.");
            fecharDialogoConfirmacaoProfessor();
        }
    };

    const abrirDialogoConfirmacaoAluno = (alunoId, nome) => {
        setDialogoConfirmacaoAluno({
            aberto: true,
            alunoId,
            nome
        });
    };

    const fecharDialogoConfirmacaoAluno = () => {
        setDialogoConfirmacaoAluno({
            aberto: false,
            alunoId: null,
            nome: ''
        });
    };

    const confirmarRemocaoAluno = async () => {
        try {
            await api.delete(`/api/turmas/${turmaId}/alunos/${dialogoConfirmacaoAluno.alunoId}`);
            buscarDadosDaPagina();
            fecharDialogoConfirmacaoAluno();
        } catch (err) {
            alert(err.response?.data?.erro || "Erro ao remover o aluno.");
            fecharDialogoConfirmacaoAluno();
        }
    };

    const abrirDialogoConfirmacaoGrupo = (grupoId, nomeGrupo) => {
        setDialogoConfirmacaoGrupo({
            aberto: true,
            grupoId,
            nome: nomeGrupo
        });
        fecharMenuAcoes();
    };

    const fecharDialogoConfirmacaoGrupo = () => {
        setDialogoConfirmacaoGrupo({
            aberto: false,
            grupoId: null,
            nome: ''
        });
    };

    const confirmarRemocaoGrupo = async () => {
        try {
            await api.delete(`/api/grupos/${dialogoConfirmacaoGrupo.grupoId}`);
            setGrupos(gruposAtuais => gruposAtuais.filter(g => g.id !== dialogoConfirmacaoGrupo.grupoId));
            fecharDialogoConfirmacaoGrupo();
        } catch (err) {
            alert(err.response?.data?.erro || "Erro ao excluir o grupo.");
            fecharDialogoConfirmacaoGrupo();
        }
    };

    const lidarComDeletarAgendamento = async (agendamento) => {
        const descricao = `${agendamento.periodo_nome} - ${agendamento.grupo_nome} - ${agendamento.caso_titulo}`;
        abrirDialogoConfirmacaoAgendamento(agendamento.id, descricao);
    };

    const abrirModalImportacao = () => {
        setArquivoSelecionado(null);
        setResultadoImportacao(null);
        setErroImportacao('');
        setModalImportacaoAberto(true);
    };

    const lidarComSelecaoDeArquivo = (evento) => {
        setArquivoSelecionado(evento.target.files[0]);
        setErroImportacao('');
        setResultadoImportacao(null);
    };

    const lidarComDownloadTemplate = async () => {
        try {
            const resposta = await api.get('/api/turmas/template-alunos', {
                responseType: 'blob',
            });
            const url = window.URL.createObjectURL(new Blob([resposta.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'template_alunos.xlsx');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (err) {
            setErroImportacao("Erro ao baixar o template.");
        }
    };

    const lidarComUpload = async () => {
        if (!arquivoSelecionado) {
            setErroImportacao("Por favor, selecione um arquivo.");
            return;
        }
        setProcessandoImportacao(true);
        setResultadoImportacao(null);
        setErroImportacao('');

        const formData = new FormData();
        formData.append('planilha', arquivoSelecionado);

        try {
            const resposta = await api.post(`/api/turmas/${turmaId}/importar-alunos`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            setResultadoImportacao(resposta.data);
            buscarDadosDaPagina();
        } catch (err) {
            setErroImportacao(err.response?.data?.erro || "Ocorreu um erro na importação.");
        } finally {
            setProcessandoImportacao(false);
        }
    };

    if (carregando) return <CircularProgress sx={{ color: cores.primaria.principal }} />;
    if (erro) return <Alert severity="error" sx={{ backgroundColor: cores.erro.claro, borderColor: cores.erro.medio, color: cores.erro.escuro }}>{erro}</Alert>;
    if (!dados) return <Typography>Turma não encontrada.</Typography>;

    return (
        <Container maxWidth="lg" sx={{ py: { xs: 3, sm: 4 } }}>
            <Paper sx={{ p: { xs: 2, sm: 4 }, borderRadius: 3, boxShadow: cores.sombras.medio }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 4,
                    p: { xs: 2, sm: 3 },
                    borderRadius: 2,
                    background: cores.gradientes.primario,
                    color: 'white'
                }}>
                    <IconButton
                        onClick={() => navegar('/gerenciar-turmas')}
                        sx={{
                            mr: 2,
                            color: 'white',
                            bgcolor: 'rgba(255,255,255,0.2)',
                            '&:hover': {
                                bgcolor: 'rgba(255,255,255,0.3)',
                            }
                        }}
                    >
                        <ArrowBack />
                    </IconButton>
                    <Box sx={{ flex: 1 }}>
                        <Typography
                            variant="h4"
                            component="h1"
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                                lineHeight: 1.2
                            }}
                        >
                            Gerenciamento da Turma: {dados.turma.nome}
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                opacity: 0.9,
                                fontSize: { xs: '0.9rem', sm: '1rem' }
                            }}
                        >
                            Semestre/Ano: {dados.turma.semestre} • Módulo: {dados.turma.modulo_nome || 'Nenhum'}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                    <Tabs
                        value={abaAtual}
                        onChange={mudarAba}
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={{
                            '& .MuiTab-root': {
                                fontWeight: 600,
                                textTransform: 'none',
                                fontSize: { xs: '0.85rem', sm: '0.95rem' },
                                minHeight: 48,
                                color: cores.cinza.medio,
                                '&.Mui-selected': {
                                    color: cores.primaria.principal,
                                }
                            },
                            '& .MuiTabs-indicator': {
                                backgroundColor: cores.primaria.principal,
                                height: 3,
                                borderRadius: '3px 3px 0 0'
                            }
                        }}
                    >
                        <Tab label="Períodos de Avaliação" />
                        <Tab label="Grupos de Tutoria" />
                        <Tab label="Cronograma de Atividades" />
                        <Tab label="Professores" />
                        <Tab label="Alunos" />
                    </Tabs>
                </Box>

                {abaAtual === 0 && (
                    <Box sx={{ mt: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, color: cores.primaria.principal }}>
                                Períodos de Avaliação (Calendário)
                            </Typography>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={() => abrirModal('PERIODO')}
                                sx={{
                                    bgcolor: cores.primaria.principal,
                                    borderRadius: 2,
                                    boxShadow: cores.sombras.suave,
                                    fontWeight: 600,
                                    '&:hover': {
                                        bgcolor: cores.primaria.escuro,
                                    }
                                }}
                            >
                                Criar Novo Período
                            </Button>
                        </Box>
                        <TableContainer
                            component={Paper}
                            sx={{
                                borderRadius: 2,
                                boxShadow: cores.sombras.suave,
                                overflow: 'hidden',
                                border: `1px solid ${cores.cinza.claro}`,
                            }}
                        >
                            <Table size="small">
                                <TableHead sx={{ bgcolor: '#f8f9fa' }}>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 700, color: cores.primaria.principal }}>Nome</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: cores.primaria.principal }}>Data Início</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: cores.primaria.principal }}>Data Fim</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 700, color: cores.primaria.principal }}>Ações</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {periodos.map((p) => (
                                        <TableRow
                                            key={p.id}
                                            hover
                                            sx={{
                                                '&:hover': {
                                                    bgcolor: '#f8fafc',
                                                }
                                            }}
                                        >
                                            <TableCell>{p.nome}</TableCell>
                                            <TableCell>{new Date(p.data_inicio).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}</TableCell>
                                            <TableCell>{new Date(p.data_fim).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}</TableCell>
                                            <TableCell align="right">
                                                <IconButton
                                                    onClick={(e) => abrirMenuAcoes(e, p.id, 'periodo')}
                                                    size="small"
                                                    sx={{
                                                        border: `1px solid ${cores.cinza.claro}`,
                                                        '&:hover': {
                                                            bgcolor: '#f1f5f9',
                                                        }
                                                    }}
                                                >
                                                    <MoreVertIcon fontSize="small" />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    {periodos.length === 0 && (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                                                <Typography variant="body1" sx={{ color: cores.cinza.medio }}>
                                                    Nenhum período de avaliação encontrado.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                )}

                {abaAtual === 1 && (
                    <Box sx={{ mt: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, color: cores.primaria.principal }}>
                                Grupos de Tutoria
                            </Typography>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={() => abrirModal('GRUPO')}
                                sx={{
                                    bgcolor: cores.primaria.principal,
                                    borderRadius: 2,
                                    boxShadow: cores.sombras.suave,
                                    fontWeight: 600,
                                    '&:hover': {
                                        bgcolor: cores.primaria.escuro,
                                    }
                                }}
                            >
                                Criar Novo Grupo
                            </Button>
                        </Box>
                        <Paper
                            sx={{
                                borderRadius: 2,
                                boxShadow: cores.sombras.suave,
                                overflow: 'hidden',
                                border: `1px solid ${cores.cinza.claro}`,
                            }}
                        >
                            <List sx={{ p: 0 }}>
                                {grupos.map((grupo, i) => (
                                    <React.Fragment key={grupo.id}>
                                        <ListItem
                                            secondaryAction={
                                                <IconButton
                                                    onClick={(e) => abrirMenuAcoes(e, grupo.id, 'grupo')}
                                                    size="small"
                                                    sx={{
                                                        border: `1px solid ${cores.cinza.claro}`,
                                                        '&:hover': {
                                                            bgcolor: '#f1f5f9',
                                                        }
                                                    }}
                                                >
                                                    <MoreVertIcon fontSize="small" />
                                                </IconButton>
                                            }
                                            sx={{ py: 1.5 }}
                                        >
                                            <ListItemText
                                                primary={
                                                    <Typography sx={{ fontWeight: 600 }}>
                                                        {grupo.nome}
                                                    </Typography>
                                                }
                                            />
                                        </ListItem>
                                        {i < grupos.length - 1 && <Divider />}
                                    </React.Fragment>
                                ))}
                                {grupos.length === 0 && (
                                    <ListItem sx={{ py: 4, justifyContent: 'center' }}>
                                        <Typography variant="body1" sx={{ color: cores.cinza.medio }}>
                                            Nenhum grupo de tutoria encontrado.
                                        </Typography>
                                    </ListItem>
                                )}
                            </List>
                        </Paper>
                    </Box>
                )}

                {abaAtual === 2 && (
                    <Box sx={{ mt: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, color: cores.primaria.principal }}>
                                Cronograma de Atividades
                            </Typography>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={() => abrirModal('AGENDAMENTO')}
                                sx={{
                                    bgcolor: cores.primaria.principal,
                                    borderRadius: 2,
                                    boxShadow: cores.sombras.suave,
                                    fontWeight: 600,
                                    '&:hover': {
                                        bgcolor: cores.primaria.escuro,
                                    }
                                }}
                            >
                                Agendar Atividade
                            </Button>
                        </Box>
                        <TableContainer
                            component={Paper}
                            sx={{
                                borderRadius: 2,
                                boxShadow: cores.sombras.suave,
                                overflow: 'hidden',
                                border: `1px solid ${cores.cinza.claro}`,
                            }}
                        >
                            <Table size="small">
                                <TableHead sx={{ bgcolor: '#f8f9fa' }}>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 700, color: cores.primaria.principal }}>Período</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: cores.primaria.principal }}>Grupo</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: cores.primaria.principal }}>Caso Clínico</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: cores.primaria.principal }}>Data de Liberação</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 700, color: cores.primaria.principal }}>Ações</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {agendamentos.map((ag) => (
                                        <TableRow
                                            key={ag.id}
                                            hover
                                            sx={{
                                                '&:hover': {
                                                    bgcolor: '#f8fafc',
                                                }
                                            }}
                                        >
                                            <TableCell>{ag.periodo_nome}</TableCell>
                                            <TableCell>{ag.grupo_nome}</TableCell>
                                            <TableCell>{ag.caso_titulo}</TableCell>
                                            <TableCell>
                                                {ag.data_liberacao ?
                                                    new Date(ag.data_liberacao).toLocaleString('pt-BR', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                    }) :
                                                    'Não definida'
                                                }
                                            </TableCell>
                                            <TableCell align="right">
                                                <Button
                                                    size="small"
                                                    color="error"
                                                    onClick={() => lidarComDeletarAgendamento(ag)}
                                                    sx={{
                                                        borderRadius: 1.5,
                                                        color: cores.erro.principal,
                                                        '&:hover': {
                                                            backgroundColor: cores.erro.claro,
                                                        }
                                                    }}
                                                >
                                                    Excluir
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    {agendamentos.length === 0 && (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                                                <Typography variant="body1" sx={{ color: cores.cinza.medio }}>
                                                    Nenhuma atividade agendada.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                )}

                {abaAtual === 3 && (
                    <Box sx={{ mt: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, color: cores.primaria.principal }}>
                                Professores Responsáveis
                            </Typography>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={() => abrirModal('PROFESSOR')}
                                sx={{
                                    bgcolor: cores.primaria.principal,
                                    borderRadius: 2,
                                    boxShadow: cores.sombras.suave,
                                    fontWeight: 600,
                                    '&:hover': {
                                        bgcolor: cores.primaria.escuro,
                                    }
                                }}
                            >
                                Adicionar Professor
                            </Button>
                        </Box>
                        <Paper
                            sx={{
                                borderRadius: 2,
                                boxShadow: cores.sombras.suave,
                                overflow: 'hidden',
                                border: `1px solid ${cores.cinza.claro}`,
                            }}
                        >
                            <List sx={{ p: 0 }}>
                                {dados.professores.map((prof, i) => (
                                    <React.Fragment key={prof.id}>
                                        <ListItem
                                            secondaryAction={
                                                <Button
                                                    size="small"
                                                    color="error"
                                                    onClick={() => lidarComRemover(prof.id, 'PROFESSOR')}
                                                    sx={{
                                                        borderRadius: 1.5,
                                                        color: cores.erro.principal,
                                                        '&:hover': {
                                                            backgroundColor: cores.erro.claro,
                                                        }
                                                    }}
                                                >
                                                    Remover
                                                </Button>
                                            }
                                            sx={{ py: 1.5 }}
                                        >
                                            <ListItemText
                                                primary={
                                                    <Typography sx={{ fontWeight: 600 }}>
                                                        {prof.nome_completo}
                                                    </Typography>
                                                }
                                                secondary={prof.email}
                                            />
                                        </ListItem>
                                        {i < dados.professores.length - 1 && <Divider />}
                                    </React.Fragment>
                                ))}
                                {dados.professores.length === 0 && (
                                    <ListItem sx={{ py: 4, justifyContent: 'center' }}>
                                        <Typography variant="body1" sx={{ color: cores.cinza.medio }}>
                                            Nenhum professor responsável encontrado.
                                        </Typography>
                                    </ListItem>
                                )}
                            </List>
                        </Paper>
                    </Box>
                )}

                {abaAtual === 4 && (
                    <Box sx={{ mt: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, color: cores.primaria.principal }}>
                                Alunos Matriculados
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                {/* NOVOS BOTÕES DE IMPORTAÇÃO */}
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={abrirModalImportacao}
                                    startIcon={<UploadIcon />}
                                    sx={{
                                        borderRadius: 2,
                                        borderColor: cores.cinza.medio,
                                        color: cores.secundaria.principal,
                                        '&:hover': {
                                            borderColor: cores.secundaria.principal,
                                            bgcolor: `rgba(${parseInt(cores.secundaria.principal.slice(1, 3), 16)}, ${parseInt(cores.secundaria.principal.slice(3, 5), 16)}, ${parseInt(cores.secundaria.principal.slice(5, 7), 16)}, 0.04)`
                                        }
                                    }}
                                >
                                    Importar Alunos
                                </Button>
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={() => abrirModal('ALUNO')}
                                    startIcon={<AddIcon />}
                                    sx={{
                                        bgcolor: cores.primaria.principal,
                                        borderRadius: 2,
                                        boxShadow: cores.sombras.suave,
                                        fontWeight: 600,
                                        '&:hover': {
                                            bgcolor: cores.primaria.escuro,
                                        }
                                    }}
                                >
                                    Adicionar Aluno
                                </Button>
                            </Box>
                        </Box>
                        <Paper
                            sx={{
                                borderRadius: 2,
                                boxShadow: cores.sombras.suave,
                                overflow: 'hidden',
                                border: `1px solid ${cores.cinza.claro}`,
                            }}
                        >
                            <List sx={{ p: 0 }}>
                                {dados.alunos.map((aluno, i) => (
                                    <React.Fragment key={aluno.id}>
                                        <ListItem
                                            secondaryAction={
                                                <Button
                                                    size="small"
                                                    color="error"
                                                    onClick={() => lidarComRemover(aluno.id, 'ALUNO')}
                                                    sx={{
                                                        borderRadius: 1.5,
                                                        color: cores.erro.principal,
                                                        '&:hover': {
                                                            backgroundColor: cores.erro.claro,
                                                        }
                                                    }}
                                                >
                                                    Remover
                                                </Button>
                                            }
                                            sx={{ py: 1.5 }}
                                        >
                                            <ListItemText
                                                primary={
                                                    <Typography sx={{ fontWeight: 600 }}>
                                                        {aluno.nome_completo}
                                                    </Typography>
                                                }
                                                secondary={`Matrícula: ${aluno.matricula}`}
                                            />
                                        </ListItem>
                                        {i < dados.alunos.length - 1 && <Divider />}
                                    </React.Fragment>
                                ))}
                                {dados.alunos.length === 0 && (
                                    <ListItem sx={{ py: 4, justifyContent: 'center' }}>
                                        <Typography variant="body1" sx={{ color: cores.cinza.medio }}>
                                            Nenhum aluno matriculado.
                                        </Typography>
                                    </ListItem>
                                )}
                            </List>
                        </Paper>
                    </Box>
                )}
            </Paper>

            <Dialog
                open={modalAberto.periodo}
                onClose={fecharModais}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: cores.sombras.forte
                    }
                }}
            >
                <DialogTitle sx={{
                    pb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar sx={{ bgcolor: `rgba(${parseInt(cores.primaria.principal.slice(1, 3), 16)}, ${parseInt(cores.primaria.principal.slice(3, 5), 16)}, ${parseInt(cores.primaria.principal.slice(5, 7), 16)}, 0.1)`, color: cores.primaria.principal }}>
                            {editandoPeriodo ? <EditIcon /> : <CalendarIcon />}
                        </Avatar>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            {editandoPeriodo ? 'Editar Período' : 'Criar Novo Período'}
                        </Typography>
                    </Box>
                    <IconButton onClick={fecharModais} size="small" sx={{ color: cores.cinza.medio }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <Divider />

                <DialogContent sx={{ pt: 3 }}>
                    <Typography
                        variant="body2"
                        sx={{ mb: 2, color: cores.cinza.medio }}
                    >
                        {editandoPeriodo
                            ? 'Atualize os detalhes do período de avaliação.'
                            : 'Configure os detalhes para o novo período de avaliação.'
                        }
                    </Typography>

                    <TextField
                        autoFocus
                        label="Nome do Período"
                        fullWidth
                        variant="outlined"
                        value={formPeriodo.nome}
                        onChange={(e) => setFormPeriodo({ ...formPeriodo, nome: e.target.value })}
                        sx={{ mb: 3 }}
                        placeholder="Ex: Primeiro Bimestre"
                        InputProps={{
                            sx: { borderRadius: 2 }
                        }}
                    />
                    <TextField
                        label="Data de Início"
                        type="date"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        value={formPeriodo.data_inicio}
                        onChange={(e) => setFormPeriodo({ ...formPeriodo, data_inicio: e.target.value })}
                        sx={{ mb: 3 }}
                        InputProps={{
                            sx: { borderRadius: 2 }
                        }}
                    />
                    <TextField
                        label="Data de Fim"
                        type="date"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        value={formPeriodo.data_fim}
                        onChange={(e) => setFormPeriodo({ ...formPeriodo, data_fim: e.target.value })}
                        InputProps={{
                            sx: { borderRadius: 2 }
                        }}
                    />
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2 }}>
                    <Button
                        onClick={fecharModais}
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            borderColor: cores.cinza.claro,
                            color: cores.cinza.escuro,
                            '&:hover': {
                                borderColor: cores.cinza.medio,
                                bgcolor: 'rgba(203, 213, 225, 0.1)'
                            }
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={lidarComSalvarPeriodo}
                        variant="contained"
                        startIcon={<CheckIcon />}
                        sx={{
                            borderRadius: 2,
                            bgcolor: cores.primaria.principal,
                            fontWeight: 600,
                            '&:hover': {
                                bgcolor: cores.primaria.escuro,
                            }
                        }}
                    >
                        {editandoPeriodo ? 'Atualizar' : 'Salvar'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={modalAberto.grupo}
                onClose={fecharModais}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: cores.sombras.forte
                    }
                }}
            >
                <DialogTitle sx={{
                    pb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar sx={{ bgcolor: `rgba(${parseInt(cores.primaria.principal.slice(1, 3), 16)}, ${parseInt(cores.primaria.principal.slice(3, 5), 16)}, ${parseInt(cores.primaria.principal.slice(5, 7), 16)}, 0.1)`, color: cores.primaria.principal }}>
                            {editandoGrupo ? <EditIcon /> : <AddIcon />}
                        </Avatar>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            {editandoGrupo ? 'Editar Grupo de Tutoria' : 'Criar Novo Grupo de Tutoria'}
                        </Typography>
                    </Box>
                    <IconButton onClick={fecharModais} size="small" sx={{ color: cores.cinza.medio }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <Divider />

                <DialogContent sx={{ pt: 3 }}>
                    <Typography
                        variant="body2"
                        sx={{ mb: 2, color: cores.cinza.medio }}
                    >
                        {editandoGrupo
                            ? 'Altere o nome do grupo de tutoria.'
                            : 'Configure o nome para o novo grupo de tutoria. Você poderá adicionar alunos ao grupo posteriormente.'}
                    </Typography>

                    <TextField
                        autoFocus
                        label="Nome do Grupo"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={novoGrupoNome}
                        onChange={(e) => setNovoGrupoNome(e.target.value)}
                        placeholder="Ex: Grupo A"
                        InputProps={{
                            sx: { borderRadius: 2 }
                        }}
                    />
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2 }}>
                    <Button
                        onClick={fecharModais}
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            borderColor: cores.cinza.claro,
                            color: cores.cinza.escuro,
                            '&:hover': {
                                borderColor: cores.cinza.medio,
                                bgcolor: 'rgba(203, 213, 225, 0.1)'
                            }
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={lidarComCriarGrupo}
                        variant="contained"
                        startIcon={<CheckIcon />}
                        sx={{
                            borderRadius: 2,
                            bgcolor: cores.primaria.principal,
                            fontWeight: 600,
                            '&:hover': {
                                bgcolor: cores.primaria.escuro,
                            }
                        }}
                    >
                        {editandoGrupo ? 'Atualizar' : 'Criar'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={modalAberto.professor}
                onClose={fecharModais}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: cores.sombras.forte
                    }
                }}
            >
                <DialogTitle sx={{
                    pb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar sx={{ bgcolor: `rgba(${parseInt(cores.primaria.principal.slice(1, 3), 16)}, ${parseInt(cores.primaria.principal.slice(3, 5), 16)}, ${parseInt(cores.primaria.principal.slice(5, 7), 16)}, 0.1)`, color: cores.primaria.principal }}>
                            <AddIcon />
                        </Avatar>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            Adicionar Professor à Turma
                        </Typography>
                    </Box>
                    <IconButton onClick={fecharModais} size="small" sx={{ color: cores.cinza.medio }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <Divider />

                <DialogContent sx={{ pt: 3 }}>
                    <Typography
                        variant="body2"
                        sx={{ mb: 2, color: cores.cinza.medio }}
                    >
                        Busque e selecione um professor para adicionar a esta turma. O professor terá acesso a todos os recursos da turma.
                    </Typography>

                    <Autocomplete
                        options={opcoesBusca}
                        getOptionLabel={(o) => `${o.nome_completo} (${o.email})`}
                        isOptionEqualToValue={(o, v) => o.id === v.id}
                        onInputChange={(e, v) => lidarComBusca(e, v, 'PROFESSOR')}
                        onChange={(e, v) => setSelecionado(v)}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                label="Buscar professor"
                                variant="outlined"
                                InputProps={{
                                    ...params.InputProps,
                                    sx: { borderRadius: 2 }
                                }}
                            />
                        }
                    />
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2 }}>
                    <Button
                        onClick={fecharModais}
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            borderColor: cores.cinza.claro,
                            color: cores.cinza.escuro,
                            '&:hover': {
                                borderColor: cores.cinza.medio,
                                bgcolor: 'rgba(203, 213, 225, 0.1)'
                            }
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={lidarComAdicionarProfessor}
                        disabled={!selecionado}
                        variant="contained"
                        startIcon={<CheckIcon />}
                        sx={{
                            borderRadius: 2,
                            bgcolor: cores.primaria.principal,
                            fontWeight: 600,
                            '&:hover': {
                                bgcolor: cores.primaria.escuro,
                            }
                        }}
                    >
                        Adicionar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={modalAberto.aluno}
                onClose={fecharModais}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: cores.sombras.forte
                    }
                }}
            >
                <DialogTitle sx={{
                    pb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar sx={{ bgcolor: `rgba(${parseInt(cores.primaria.principal.slice(1, 3), 16)}, ${parseInt(cores.primaria.principal.slice(3, 5), 16)}, ${parseInt(cores.primaria.principal.slice(5, 7), 16)}, 0.1)`, color: cores.primaria.principal }}>
                            <AddIcon />
                        </Avatar>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            {modoCriacaoAluno ? 'Cadastrar Novo Aluno' : 'Adicionar Aluno à Turma'}
                        </Typography>
                    </Box>
                    <IconButton onClick={fecharModais} size="small" sx={{ color: cores.cinza.medio }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <Divider />

                <DialogContent sx={{ pt: 3 }}>
                    <Typography
                        variant="body2"
                        sx={{ mb: 2, color: cores.cinza.medio }}
                    >
                        {modoCriacaoAluno
                            ? 'Preencha os dados para cadastrar um novo aluno e adicioná-lo à turma.'
                            : 'Busque e selecione um aluno para adicionar a esta turma.'
                        }
                    </Typography>

                    {!modoCriacaoAluno ? (
                        <>
                            <Autocomplete
                                options={opcoesBusca}
                                getOptionLabel={(o) => `${o.nome_completo} (${o.matricula})`}
                                isOptionEqualToValue={(o, v) => o.id === v.id}
                                onInputChange={(e, v) => lidarComBusca(e, v, 'ALUNO')}
                                onChange={(e, v) => setSelecionado(v)}
                                noOptionsText="Nenhum aluno disponível."
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label="Buscar aluno"
                                        variant="outlined"
                                        sx={{ mb: 2 }}
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: 2 }
                                        }}
                                    />
                                }
                            />
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    mt: 1,
                                    borderRadius: 2,
                                    bgcolor: 'rgba(96, 165, 250, 0.08)',
                                    border: '1px dashed rgba(96, 165, 250, 0.3)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <AddIcon fontSize="small" sx={{ color: '#3b82f6' }} />
                                    <Typography variant="body2" sx={{ color: '#3b82f6' }}>
                                        Não encontrou o aluno que procura?
                                    </Typography>
                                </Box>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={() => setModoCriacaoAluno(true)}
                                    startIcon={<AddIcon />}
                                    sx={{
                                        borderRadius: 1.5,
                                        borderColor: '#3b82f6',
                                        color: '#3b82f6',
                                        fontSize: '0.8rem',
                                        '&:hover': {
                                            bgcolor: 'rgba(59, 130, 246, 0.08)',
                                            borderColor: '#2563eb'
                                        }
                                    }}
                                >
                                    Cadastrar Novo
                                </Button>
                            </Paper>
                        </>
                    ) : (
                        <>
                            <TextField
                                label="Nome Completo"
                                fullWidth
                                variant="outlined"
                                value={novoAluno.nome}
                                onChange={(e) => setNovoAluno({ ...novoAluno, nome: e.target.value })}
                                sx={{ mb: 3 }}
                                InputProps={{
                                    sx: { borderRadius: 2 }
                                }}
                            />
                            <TextField
                                label="Matrícula"
                                fullWidth
                                variant="outlined"
                                value={novoAluno.matricula}
                                onChange={(e) => setNovoAluno({ ...novoAluno, matricula: e.target.value })}
                                sx={{ mb: 3 }}
                                InputProps={{
                                    sx: { borderRadius: 2 }
                                }}
                            />
                            <TextField
                                label="Email"
                                type="email"
                                fullWidth
                                variant="outlined"
                                value={novoAluno.email}
                                onChange={(e) => setNovoAluno({ ...novoAluno, email: e.target.value })}
                                sx={{ mb: 3 }}
                                InputProps={{
                                    sx: { borderRadius: 2 }
                                }}
                            />
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    mt: 1,
                                    borderRadius: 2,
                                    bgcolor: 'rgba(96, 165, 250, 0.08)',
                                    border: '1px dashed rgba(96, 165, 250, 0.3)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography variant="body2" sx={{ color: '#3b82f6', display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <ArrowBack fontSize="small" />
                                    Prefere buscar um aluno existente?
                                </Typography>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={() => setModoCriacaoAluno(false)}
                                    sx={{
                                        borderRadius: 1.5,
                                        borderColor: '#3b82f6',
                                        color: '#3b82f6',
                                        fontSize: '0.8rem',
                                        '&:hover': {
                                            bgcolor: 'rgba(59, 130, 246, 0.08)',
                                            borderColor: '#2563eb'
                                        }
                                    }}
                                >
                                    Voltar para busca
                                </Button>
                            </Paper>
                        </>
                    )}
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2 }}>
                    <Button
                        onClick={fecharModais}
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            borderColor: cores.cinza.claro,
                            color: cores.cinza.escuro,
                            '&:hover': {
                                borderColor: cores.cinza.medio,
                                bgcolor: 'rgba(203, 213, 225, 0.1)'
                            }
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={lidarComAdicionarAluno}
                        disabled={!modoCriacaoAluno && !selecionado}
                        variant="contained"
                        startIcon={<CheckIcon />}
                        sx={{
                            borderRadius: 2,
                            bgcolor: cores.primaria.principal,
                            fontWeight: 600,
                            '&:hover': {
                                bgcolor: cores.primaria.escuro,
                            }
                        }}
                    >
                        {modoCriacaoAluno ? 'Criar e Adicionar' : 'Adicionar'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={modalAberto.agendamento}
                onClose={fecharModais}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: cores.sombras.forte
                    }
                }}
            >
                <DialogTitle sx={{
                    pb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar sx={{ bgcolor: `rgba(${parseInt(cores.primaria.principal.slice(1, 3), 16)}, ${parseInt(cores.primaria.principal.slice(3, 5), 16)}, ${parseInt(cores.primaria.principal.slice(5, 7), 16)}, 0.1)`, color: cores.primaria.principal }}>
                            <CalendarIcon />
                        </Avatar>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            Agendar Nova Atividade
                        </Typography>
                    </Box>
                    <IconButton onClick={fecharModais} size="small" sx={{ color: cores.cinza.medio }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <Divider />

                <DialogContent sx={{ pt: 3 }}>
                    <Typography
                        variant="body2"
                        sx={{ mb: 2, color: cores.cinza.medio }}
                    >
                        Selecione o grupo, o caso clínico e o período para agendar uma nova atividade no cronograma.
                    </Typography>

                    <FormControl
                        fullWidth
                        sx={{ mb: 3 }}
                    >
                        <InputLabel id="grupo-select-label">Grupo de Tutoria</InputLabel>
                        <Select
                            labelId="grupo-select-label"
                            name="grupo_tutoria_id"
                            value={novoAgendamento.grupo_tutoria_id}
                            label="Grupo de Tutoria"
                            onChange={lidarComMudancaAgendamento}
                            sx={{ borderRadius: 2 }}
                        >
                            {listasParaModal.grupos.map(g => (
                                <MenuItem key={g.id} value={g.id}>{g.nome}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl
                        fullWidth
                        sx={{ mb: 3 }}
                    >
                        <InputLabel id="caso-select-label">Caso Clínico</InputLabel>
                        <Select
                            labelId="caso-select-label"
                            name="caso_clinico_id"
                            value={novoAgendamento.caso_clinico_id}
                            label="Caso Clínico"
                            onChange={lidarComMudancaAgendamento}
                            sx={{ borderRadius: 2 }}
                        >
                            {listasParaModal.casos.map(c => (
                                <MenuItem key={c.id} value={c.id}>{c.titulo}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl
                        fullWidth
                        sx={{ mb: 3 }}
                    >
                        <InputLabel id="periodo-select-label">Período de Avaliação</InputLabel>
                        <Select
                            labelId="periodo-select-label"
                            name="periodo_avaliacao_id"
                            value={novoAgendamento.periodo_avaliacao_id}
                            label="Período de Avaliação"
                            onChange={lidarComMudancaAgendamento}
                            sx={{ borderRadius: 2 }}
                        >
                            {listasParaModal.periodos.map(p => (
                                <MenuItem key={p.id} value={p.id}>{p.nome}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <TextField
                        label="Data e Hora de Liberação"
                        type="datetime-local"
                        fullWidth
                        variant="outlined"
                        name="data_liberacao"
                        value={novoAgendamento.data_liberacao}
                        onChange={lidarComMudancaAgendamento}
                        InputLabelProps={{ shrink: true }}
                        sx={{ mb: 3 }}
                        InputProps={{
                            sx: { borderRadius: 2 }
                        }}
                        helperText="Defina quando a atividade será disponibilizada para os alunos"
                    />

                    <Paper
                        elevation={0}
                        sx={{
                            mt: 3,
                            p: 2,
                            borderRadius: 2,
                            bgcolor: 'rgba(96, 165, 250, 0.1)',
                            border: '1px solid rgba(96, 165, 250, 0.2)',
                        }}
                    >
                        <Typography variant="body2" sx={{ color: '#3b82f6', display: 'flex', alignItems: 'center', gap: 1 }}>
                            <CalendarIcon fontSize="small" />
                            <span>
                                <strong>Nota:</strong> Esta atividade ficará disponível para os alunos durante todo o período selecionado.
                            </span>
                        </Typography>
                    </Paper>
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2 }}>
                    <Button
                        onClick={fecharModais}
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            borderColor: cores.cinza.claro,
                            color: cores.cinza.escuro,
                            '&:hover': {
                                borderColor: cores.cinza.medio,
                                bgcolor: 'rgba(203, 213, 225, 0.1)'
                            }
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={lidarComSalvarAgendamento}
                        variant="contained"
                        startIcon={<CheckIcon />}
                        sx={{
                            borderRadius: 2,
                            bgcolor: cores.primaria.principal,
                            fontWeight: 600,
                            '&:hover': {
                                bgcolor: cores.primaria.escuro,
                            }
                        }}
                    >
                        Salvar Agendamento
                    </Button>
                </DialogActions>
            </Dialog>

            {/* ================================================================ */}
            {/* ===== NOVO MODAL PARA IMPORTAÇÃO =============================== */}
            {/* ================================================================ */}
            <Dialog
                open={modalImportacaoAberto}
                onClose={() => setModalImportacaoAberto(false)}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: cores.sombras.forte
                    }
                }}
            >
                <DialogTitle sx={{
                    pb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar sx={{ bgcolor: `rgba(${parseInt(cores.secundaria.principal.slice(1, 3), 16)}, ${parseInt(cores.secundaria.principal.slice(3, 5), 16)}, ${parseInt(cores.secundaria.principal.slice(5, 7), 16)}, 0.1)`, color: cores.secundaria.principal }}>
                            <UploadIcon />
                        </Avatar>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            Importar Alunos de Planilha
                        </Typography>
                    </Box>
                    <IconButton onClick={() => setModalImportacaoAberto(false)} size="small" sx={{ color: cores.cinza.medio }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <Divider />

                <DialogContent sx={{ pt: 3 }}>
                    <Box sx={{ my: 2 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: cores.primaria.principal, mb: 1 }}>
                            Passo 1: Baixe o modelo
                        </Typography>
                        <Button
                            variant="outlined"
                            onClick={lidarComDownloadTemplate}
                            startIcon={<CloudDownloadIcon />}
                            sx={{
                                borderRadius: 2,
                                borderColor: cores.cinza.medio,
                                color: cores.secundaria.principal,
                                mb: 1,
                                '&:hover': {
                                    borderColor: cores.secundaria.principal,
                                    bgcolor: `rgba(${parseInt(cores.secundaria.principal.slice(1, 3), 16)}, ${parseInt(cores.secundaria.principal.slice(3, 5), 16)}, ${parseInt(cores.secundaria.principal.slice(5, 7), 16)}, 0.04)`
                                }
                            }}
                        >
                            Baixar planilha modelo
                        </Button>
                        <Typography variant="body2" color={cores.cinza.escuro}>
                            Preencha o arquivo com os dados dos alunos (nome_completo, matricula, email) e salve em seu computador.
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 3 }} />

                    <Box sx={{ my: 2 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: cores.primaria.principal, mb: 1 }}>
                            Passo 2: Envie o arquivo preenchido
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                            <Button
                                variant="contained"
                                component="label"
                                startIcon={<FileUploadIcon />}
                                sx={{
                                    borderRadius: 2,
                                    bgcolor: cores.secundaria.principal,
                                    fontWeight: 600,
                                    boxShadow: cores.sombras.suave,
                                    '&:hover': {
                                        bgcolor: cores.secundaria.clara,
                                    }
                                }}
                            >
                                Selecionar Arquivo
                                <input type="file" hidden accept=".xlsx" onChange={lidarComSelecaoDeArquivo} />
                            </Button>
                            {arquivoSelecionado && (
                                <Typography variant="body2" sx={{ color: cores.cinza.escuro }}>
                                    {arquivoSelecionado.name}
                                </Typography>
                            )}
                        </Box>

                        {processandoImportacao && (
                            <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
                                <CircularProgress sx={{ color: cores.primaria.principal }} />
                            </Box>
                        )}

                        {resultadoImportacao && (
                            <Alert
                                severity="success"
                                sx={{
                                    mt: 2,
                                    borderRadius: 2,
                                    backgroundColor: cores.sucesso.claro || '#dcfce7',
                                    color: cores.sucesso.escuro || '#166534',
                                    '& .MuiAlert-icon': {
                                        alignItems: 'center'
                                    }
                                }}
                            >
                                {`Importação Concluída! Total na planilha: ${resultadoImportacao.totalNaPlanilha}. Adicionados/Vinculados agora: ${resultadoImportacao.adicionadosAgora}.`}
                            </Alert>
                        )}

                        {erroImportacao && (
                            <Alert
                                severity="error"
                                sx={{
                                    mt: 2,
                                    borderRadius: 2,
                                    backgroundColor: cores.erro.claro,
                                    borderColor: cores.erro.medio,
                                    color: cores.erro.escuro,
                                    '& .MuiAlert-icon': {
                                        alignItems: 'center'
                                    }
                                }}
                            >
                                {erroImportacao}
                            </Alert>
                        )}
                    </Box>
                </DialogContent>

                <DialogActions sx={{ px: 3, py: 2 }}>
                    <Button
                        onClick={() => setModalImportacaoAberto(false)}
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            borderColor: cores.cinza.claro,
                            color: cores.cinza.escuro,
                            '&:hover': {
                                borderColor: cores.cinza.medio,
                                bgcolor: 'rgba(203, 213, 225, 0.1)'
                            }
                        }}
                    >
                        Fechar
                    </Button>
                    <Button
                        onClick={lidarComUpload}
                        disabled={!arquivoSelecionado || processandoImportacao}
                        variant="contained"
                        startIcon={<UploadIcon />}
                        sx={{
                            borderRadius: 2,
                            bgcolor: cores.primaria.principal,
                            fontWeight: 600,
                            '&:hover': {
                                bgcolor: cores.primaria.escuro,
                            },
                            '&.Mui-disabled': {
                                bgcolor: cores.cinza.claro,
                                color: cores.cinza.medio
                            }
                        }}
                    >
                        {processandoImportacao ? 'Processando...' : 'Enviar e Processar'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={dialogoConfirmacao.aberto}
                onClose={fecharDialogoConfirmacao}
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: cores.sombras.forte,
                        maxWidth: 450
                    }
                }}
            >
                <DialogTitle sx={{
                    bgcolor: cores.erro.claro,
                    color: cores.erro.escuro,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    fontWeight: 700,
                    py: 2
                }}>
                    <WarningIcon color="error" fontSize="small" />
                    Confirmar Exclusão
                </DialogTitle>
                <DialogContent sx={{ pt: 3, pb: 1 }}>
                    <DialogContentText sx={{ color: cores.cinza.escuro, mb: 2 }}>
                        Você está prestes a excluir o período <strong>{dialogoConfirmacao.nomePeriodo}</strong>. Esta ação não poderá ser desfeita.
                    </DialogContentText>
                    <DialogContentText sx={{
                        color: cores.erro.escuro,
                        bgcolor: cores.erro.claro,
                        p: 2,
                        borderRadius: 2,
                        fontSize: '0.9rem',
                        fontWeight: 500,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}>
                        <WarningIcon fontSize="small" sx={{ color: cores.erro.medio }} />
                        Todas as atividades agendadas para este período serão afetadas.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2, justifyContent: 'space-between' }}>
                    <Button
                        onClick={fecharDialogoConfirmacao}
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            color: cores.cinza.escuro,
                            borderColor: cores.cinza.claro,
                            '&:hover': {
                                backgroundColor: '#f1f5f9',
                                borderColor: cores.cinza.medio
                            },
                            px: 2
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={confirmarDelecaoPeriodo}
                        variant="contained"
                        color="error"
                        sx={{
                            borderRadius: 2,
                            fontWeight: 600,
                            boxShadow: `0 4px 12px rgba(${parseInt(cores.erro.principal.slice(1, 3), 16)}, ${parseInt(cores.erro.principal.slice(3, 5), 16)}, ${parseInt(cores.erro.principal.slice(5, 7), 16)}, 0.2)`,
                            px: 3,
                            '&:hover': {
                                backgroundColor: cores.erro.escuro,
                                boxShadow: `0 4px 12px rgba(${parseInt(cores.erro.principal.slice(1, 3), 16)}, ${parseInt(cores.erro.principal.slice(3, 5), 16)}, ${parseInt(cores.erro.principal.slice(5, 7), 16)}, 0.3)`
                            }
                        }}
                    >
                        Excluir Período
                    </Button>
                </DialogActions>
            </Dialog>

            <Menu
                anchorEl={menuAnchorEl.element}
                open={Boolean(menuAnchorEl.element)}
                onClose={fecharMenuAcoes}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    elevation: 2,
                    sx: {
                        borderRadius: 2,
                        minWidth: 180,
                        boxShadow: cores.sombras.medio,
                        '& .MuiList-root': {
                            py: 1
                        }
                    }
                }}
            >
                {(!menuAnchorEl.tipo || menuAnchorEl.tipo === 'periodo') && (
                    <>
                        <MenuItem
                            onClick={() => {
                                const periodo = periodos.find(p => p.id === menuAnchorEl.id);
                                abrirModal('PERIODO', periodo);
                                fecharMenuAcoes();
                            }}
                            sx={{ py: 1 }}
                        >
                            <ListItemIcon>
                                <EditIcon fontSize="small" sx={{ color: cores.primaria.principal }} />
                            </ListItemIcon>
                            <ListItemText>Editar</ListItemText>
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                const periodo = periodos.find(p => p.id === menuAnchorEl.id);
                                abrirDialogoConfirmacao(menuAnchorEl.id, periodo?.nome || '');
                            }}
                            sx={{
                                py: 1,
                                color: cores.erro.principal
                            }}
                        >
                            <ListItemIcon>
                                <DeleteIcon fontSize="small" sx={{ color: cores.erro.principal }} />
                            </ListItemIcon>
                            <ListItemText>Excluir</ListItemText>
                        </MenuItem>
                    </>
                )}

                {menuAnchorEl.tipo === 'grupo' && (
                    <>
                        <MenuItem
                            onClick={() => {
                                navegar(`/grupos/${menuAnchorEl.id}`);
                                fecharMenuAcoes();
                            }}
                            sx={{ py: 1 }}
                        >
                            <ListItemIcon>
                                <ManageAccountsIcon fontSize="small" sx={{ color: cores.primaria.principal }} />
                            </ListItemIcon>
                            <ListItemText>Gerenciar</ListItemText>
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                const grupo = grupos.find(g => g.id === menuAnchorEl.id);
                                abrirModal('GRUPO', grupo);
                                fecharMenuAcoes();
                            }}
                            sx={{ py: 1 }}
                        >
                            <ListItemIcon>
                                <EditIcon fontSize="small" sx={{ color: cores.primaria.principal }} />
                            </ListItemIcon>
                            <ListItemText>Editar</ListItemText>
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                const grupo = grupos.find(g => g.id === menuAnchorEl.id);
                                abrirDialogoConfirmacaoGrupo(menuAnchorEl.id, grupo?.nome || '');
                            }}
                            sx={{
                                py: 1,
                                color: cores.erro.principal
                            }}
                        >
                            <ListItemIcon>
                                <DeleteIcon fontSize="small" sx={{ color: cores.erro.principal }} />
                            </ListItemIcon>
                            <ListItemText>Excluir</ListItemText>
                        </MenuItem>
                    </>
                )}
            </Menu>

            <Dialog
                open={dialogoConfirmacaoAgendamento.aberto}
                onClose={fecharDialogoConfirmacaoAgendamento}
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: cores.sombras.forte,
                        maxWidth: 450
                    }
                }}
            >
                <DialogTitle sx={{
                    bgcolor: cores.erro.claro,
                    color: cores.erro.escuro,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    fontWeight: 700,
                    py: 2
                }}>
                    <WarningIcon color="error" fontSize="small" />
                    Confirmar Exclusão
                </DialogTitle>
                <DialogContent sx={{ pt: 3, pb: 1 }}>
                    <DialogContentText sx={{ color: cores.cinza.escuro, mb: 2 }}>
                        Você está prestes a excluir o agendamento <strong>{dialogoConfirmacaoAgendamento.descricao}</strong>. Esta ação não poderá ser desfeita.
                    </DialogContentText>
                    <DialogContentText sx={{
                        color: cores.erro.escuro,
                        bgcolor: cores.erro.claro,
                        p: 2,
                        borderRadius: 2,
                        fontSize: '0.9rem',
                        fontWeight: 500,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}>
                        <WarningIcon fontSize="small" sx={{ color: cores.erro.medio }} />
                        Esta atividade será removida do cronograma de todos os alunos associados.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2, justifyContent: 'space-between' }}>
                    <Button
                        onClick={fecharDialogoConfirmacaoAgendamento}
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            color: cores.cinza.escuro,
                            borderColor: cores.cinza.claro,
                            '&:hover': {
                                backgroundColor: '#f1f5f9',
                                borderColor: cores.cinza.medio
                            },
                            px: 2
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={confirmarDelecaoAgendamento}
                        variant="contained"
                        color="error"
                        sx={{
                            borderRadius: 2,
                            fontWeight: 600,
                            boxShadow: `0 4px 12px rgba(${parseInt(cores.erro.principal.slice(1, 3), 16)}, ${parseInt(cores.erro.principal.slice(3, 5), 16)}, ${parseInt(cores.erro.principal.slice(5, 7), 16)}, 0.2)`,
                            px: 3,
                            '&:hover': {
                                backgroundColor: cores.erro.escuro,
                                boxShadow: `0 4px 12px rgba(${parseInt(cores.erro.principal.slice(1, 3), 16)}, ${parseInt(cores.erro.principal.slice(3, 5), 16)}, ${parseInt(cores.erro.principal.slice(5, 7), 16)}, 0.3)`
                            }
                        }}
                    >
                        Excluir Agendamento
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={dialogoConfirmacaoProfessor.aberto}
                onClose={fecharDialogoConfirmacaoProfessor}
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: cores.sombras.forte,
                        maxWidth: 450
                    }
                }}
            >
                <DialogTitle sx={{
                    bgcolor: cores.erro.claro,
                    color: cores.erro.escuro,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    fontWeight: 700,
                    py: 2
                }}>
                    <WarningIcon color="error" fontSize="small" />
                    Confirmar Remoção
                </DialogTitle>
                <DialogContent sx={{ pt: 3, pb: 1 }}>
                    <DialogContentText sx={{ color: cores.cinza.escuro, mb: 2 }}>
                        Você está prestes a remover o professor <strong>{dialogoConfirmacaoProfessor.nome}</strong> desta turma.
                    </DialogContentText>
                    <DialogContentText sx={{
                        color: cores.erro.escuro,
                        bgcolor: cores.erro.claro,
                        p: 2,
                        borderRadius: 2,
                        fontSize: '0.9rem',
                        fontWeight: 500,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}>
                        <WarningIcon fontSize="small" sx={{ color: cores.erro.medio }} />
                        O professor perderá acesso a todos os recursos desta turma.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2, justifyContent: 'space-between' }}>
                    <Button
                        onClick={fecharDialogoConfirmacaoProfessor}
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            color: cores.cinza.escuro,
                            borderColor: cores.cinza.claro,
                            '&:hover': {
                                backgroundColor: '#f1f5f9',
                                borderColor: cores.cinza.medio
                            },
                            px: 2
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={confirmarRemocaoProfessor}
                        variant="contained"
                        color="error"
                        sx={{
                            borderRadius: 2,
                            fontWeight: 600,
                            boxShadow: `0 4px 12px rgba(${parseInt(cores.erro.principal.slice(1, 3), 16)}, ${parseInt(cores.erro.principal.slice(3, 5), 16)}, ${parseInt(cores.erro.principal.slice(5, 7), 16)}, 0.2)`,
                            px: 3,
                            '&:hover': {
                                backgroundColor: cores.erro.escuro,
                                boxShadow: `0 4px 12px rgba(${parseInt(cores.erro.principal.slice(1, 3), 16)}, ${parseInt(cores.erro.principal.slice(3, 5), 16)}, ${parseInt(cores.erro.principal.slice(5, 7), 16)}, 0.3)`
                            }
                        }}
                    >
                        Remover Professor
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={dialogoConfirmacaoAluno.aberto}
                onClose={fecharDialogoConfirmacaoAluno}
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: cores.sombras.forte,
                        maxWidth: 450
                    }
                }}
            >
                <DialogTitle sx={{
                    bgcolor: cores.erro.claro,
                    color: cores.erro.escuro,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    fontWeight: 700,
                    py: 2
                }}>
                    <WarningIcon />
                    Confirmar Remoção
                </DialogTitle>
                <DialogContent sx={{ pt: 3, pb: 1 }}>
                    <DialogContentText sx={{ color: cores.cinza.escuro, mb: 2 }}>
                        Você está prestes a remover o aluno <strong>{dialogoConfirmacaoAluno.nome}</strong> desta turma.
                    </DialogContentText>
                    <DialogContentText sx={{
                        color: cores.erro.escuro,
                        bgcolor: cores.erro.claro,
                        p: 2,
                        borderRadius: 2,
                        fontSize: '0.9rem',
                        fontWeight: 500,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}>
                        <WarningIcon fontSize="small" sx={{ color: cores.erro.medio }} />
                        O aluno perderá acesso a todos os recursos desta turma e suas atividades serão removidas.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2, justifyContent: 'space-between' }}>
                    <Button
                        onClick={fecharDialogoConfirmacaoAluno}
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            color: cores.cinza.escuro,
                            borderColor: cores.cinza.claro,
                            '&:hover': {
                                backgroundColor: '#f1f5f9',
                                borderColor: cores.cinza.medio
                            },
                            px: 2
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={confirmarRemocaoAluno}
                        variant="contained"
                        color="error"
                        sx={{
                            borderRadius: 2,
                            fontWeight: 600,
                            boxShadow: `0 4px 12px rgba(${parseInt(cores.erro.principal.slice(1, 3), 16)}, ${parseInt(cores.erro.principal.slice(3, 5), 16)}, ${parseInt(cores.erro.principal.slice(5, 7), 16)}, 0.2)`,
                            px: 3,
                            '&:hover': {
                                backgroundColor: cores.erro.escuro,
                                boxShadow: `0 4px 12px rgba(${parseInt(cores.erro.principal.slice(1, 3), 16)}, ${parseInt(cores.erro.principal.slice(3, 5), 16)}, ${parseInt(cores.erro.principal.slice(5, 7), 16)}, 0.3)`
                            }
                        }}
                    >
                        Remover Aluno
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={dialogoConfirmacaoGrupo.aberto}
                onClose={fecharDialogoConfirmacaoGrupo}
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: cores.sombras.forte,
                        maxWidth: 450
                    }
                }}
            >
                <DialogTitle sx={{
                    bgcolor: cores.erro.claro,
                    color: cores.erro.escuro,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    fontWeight: 700,
                    py: 2
                }}>
                    <WarningIcon />
                    Confirmar Exclusão
                </DialogTitle>
                <DialogContent sx={{ pt: 3, pb: 2 }}>
                    <DialogContentText>
                        Tem certeza que deseja excluir o grupo de tutoria <strong>{dialogoConfirmacaoGrupo.nome}</strong>? Esta ação não pode ser desfeita.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 3 }}>
                    <Button
                        onClick={fecharDialogoConfirmacaoGrupo}
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            color: cores.cinza.escuro,
                            borderColor: cores.cinza.claro,
                            '&:hover': {
                                backgroundColor: '#f1f5f9',
                                borderColor: cores.cinza.medio
                            },
                            px: 2
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={confirmarRemocaoGrupo}
                        variant="contained"
                        color="error"
                        sx={{
                            borderRadius: 2,
                            fontWeight: 600,
                            boxShadow: `0 4px 12px rgba(${parseInt(cores.erro.principal.slice(1, 3), 16)}, ${parseInt(cores.erro.principal.slice(3, 5), 16)}, ${parseInt(cores.erro.principal.slice(5, 7), 16)}, 0.2)`,
                            px: 3,
                            '&:hover': {
                                backgroundColor: cores.erro.escuro,
                                boxShadow: `0 4px 12px rgba(${parseInt(cores.erro.principal.slice(1, 3), 16)}, ${parseInt(cores.erro.principal.slice(3, 5), 16)}, ${parseInt(cores.erro.principal.slice(5, 7), 16)}, 0.3)`
                            }
                        }}
                    >
                        Excluir Grupo
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default TurmaDetalhePagina;